var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Daily Journey")]),_vm._v(" "),_c('h1',[_vm._v("JotForm External Script")]),_vm._v(" "),_c('aha-external-script',{attrs:{"id":"jt2","src":"https://form.jotform.com/jsform/83334336746158"}}),_vm._v(" "),_c('div',[_c('aha-external-script',{attrs:{"id":"jt12","src":"https://form.jotform.com/jsform/202796431116049"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49407abc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/pages/components/external-script.vue
// module id = 1446
// module chunks = 0